<!-- 锁到家项目，特别给5815 zone 使用-->
<template>
  <div class="light">
    <div class="header">
      <div class="title">门锁列表</div>
      <div class="fast-btn">

      </div>
    </div>
    <div class="container">
      <div class="group-device">
      <div class="round">
        <div class="header">
          <div>
            <span title="前门">前门</span>
          </div>
          <div >
            <img  style="width: 85px;">
          </div>
        </div>
        <div  class="content">
          <div  class="middle" style="margin-top: 20px;" @click="openDoor('4185d05fe32c1a4cf688938c93b91a14',1)">
            <div  class="placeholder" style="width: 5px;"></div>
            <div>
              <img v-if="!state1" src="@/assets/images/device/door.png" style="height: 65px;">
              <img v-if="state1" src="@/assets/images/device/door-k.png" style="height: 65px;">
            </div>
            <div class="star">
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="footer-radius"></div>
        </div>
      </div>
      </div>
      <div class="group-device">
      <div class="round">
        <div class="header">
          <div>
            <span title="后门">后门</span>
          </div>
          <div >
            <img  style="width: 85px;">
          </div>
        </div>
        <div  class="content">
          <div  class="middle" style="margin-top: 20px;" @click="openDoor('96b54eefc68c685f408eecdf856a27b7',2)">
            <div  class="placeholder" style="width: 5px;"></div>
            <div>
              <img v-if="!state2" src="@/assets/images/device/door.png" style="height: 65px;">
              <img v-if="state2" src="@/assets/images/device/door-k.png" style="height: 65px;">
            </div>
            <div class="star">
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="footer-radius"></div>
        </div>
      </div>
      </div>
      <div class="group-device">
      <div class="round">
        <div class="header">
          <div>
            <span title="准备室">准备室</span>
          </div>
          <div >
            <img  style="width: 85px;">
          </div>
        </div>
        <div  class="content">
          <div  class="middle" style="margin-top: 20px;" @click="openDoor('582d280a9d4ed0cbf0f30d3f725caea8',3)">
            <div  class="placeholder" style="width: 5px;"></div>
            <div>
              <img v-if="!state3" src="@/assets/images/device/door.png" style="height: 65px;">
              <img v-if="state3" src="@/assets/images/device/door-k.png" style="height: 65px;">
            </div>
            <div class="star">
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="footer-radius"></div>
        </div>
      </div>
      </div>
      <round class="empty"></round>
    </div>
  </div>
</template>

<script>
import Round from '@/components/Round'
import { Message } from 'element-ui'
import api from '@/model/device'

export default {
  data () {
    return {
      state1: false,
      state2: false,
      state3: false
    }
  },
  computed: {
  },
  components: {
    Round
  },
  methods: {
    async openDoor (deviceCode,i) {
      await api.openDoor(deviceCode)
      if(i==1) {
        this.state1=true
      }
      else if(i==2) {
        this.state2=true
      }
      else if(i==3) {
        this.state3=true
      }
      Message.warning('门已打开')
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/base";

.light {
  display: flex;
  flex-direction: column;
  flex: 1;
  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    > .title {
      font-size: 17px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
    }
    > .fast-btn {
      display: flex;
      align-items: center;
    }
  }
  > .container {
    overflow-y: auto;
    margin-top: 5px;
    flex: 1;
    height: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      margin-top: 20px;
    }
        > .group-device {
      position: relative;
      box-sizing: border-box;
      height: 260px;
      min-width: 230px;
      max-width: 24%;
      .group-edit {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.2;
      }
      .group-checkbox {
        position: absolute;
        bottom: 24px;
        right: 24px;
        width: 30px;
        height: 30px;
        z-index: 1;
      }
      .unchecked {
          background: url('../../assets/images/group/unchecked.png') no-repeat center;
          background-size:cover;
      }
      .checked {
          background: url('../../assets/images/group/checked.png') no-repeat center;
          background-size:cover;
      }
    }
  }
}
</style>
<style scoped lang="less">
@import "../../assets/less/base";

.round {
  padding: 20px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 17px 2px rgba(219, 219, 219, 0.3);
  border-radius: 8px;
  display: flex;
  height: 260px;
  min-width: 230px;
  max-width: 24%;
  flex-direction: column;
  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 33px;
    > div:first-child {
      flex: 1;
      .auto-hide;
      font-size: 18px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
      margin-right: 8px;
      width: 0;
    }
    > div:last-child {
      .text-right;
      width: 85px;
    }
    img {
      cursor: pointer;
    }
  }
  .content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .middle {
      display: flex;
      padding: 15px 0px;
      height: 100%;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      > .placeholder {
        width: 28px;
      }
      .star {
        display: flex;
        align-items: flex-start;
        height: 100%;
      }
      img {
        cursor: pointer;
      }
    }
  }
  .footer {
    height: 66px;
  }
}
</style>

